export default __webpack_public_path__ + "static/muros1-823ccef86161b1699e655a1e99a66261.jpg";